import React, { Component } from 'react'

class Button extends Component {
  render() {
    const { label, link, type, tag } = this.props;

    if (type === 'a') {
      return (
        <a href={link} className='button'>
          {label}
        </a>
      );
    }

    const buttonType = type ? type : 'button';

    return (
      <button type={buttonType} className='button'>
        {label}
      </button>
    );
  }
}

export default Button



// WEBPACK FOOTER //
// ./src/components/Button/index.js